import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { CustomerBonusSettlementDetails } from '../../models/customer-bonus-settlement-details';
import { CustomerBonusSettlementSupplier } from '../../models/customer-bonus-settlement-supplier';
import { PoolCustomerBonusSettlementSupplier } from '../../models/pool-customer-bonus-settlement-supplier';

export class BonusSettlementsDetailApi {
    constructor(protected baseUrl: string) {}

    public getCustomerBonusSettlementDetails(id: number): Promise<ApiResult<CustomerBonusSettlementDetails>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/bonus-settlements/${id}/details`),
            response => response.data
        );
    }

    public getPoolCustomerBonusSettlementDetails(id: number): Promise<ApiResult<CustomerBonusSettlementDetails>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/bonus-settlements/${id}/pool-details`),
            response => response.data
        );
    }

    public getBonusSettlementSuppliers(
        id: number,
        searchParams?: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<CustomerBonusSettlementSupplier>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/bonus-settlements/${id}/suppliers`, { params: searchParams }),
            response => response.data
        );
    }

    public getPoolBonusSettlementCustomers(
        id: number,
        searchParams?: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<PoolCustomerBonusSettlementSupplier>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/bonus-settlements/${id}/pool-customers`, { params: searchParams }),
            response => response.data
        );
    }

    public getPoolBonusSettlementCustomerSuppliers(
        id: number,
        customerId: number,
        searchParams?: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<CustomerBonusSettlementSupplier>>> {
        return safeRequest(
            () =>
                request.get(`${this.baseUrl}/bonus-settlements/${id}/pool-customers/${customerId}/suppliers`, {
                    params: searchParams,
                }),
            response => response.data
        );
    }
    public getPoolBonusSettlementCustomerDetails(
        id: number,
        customerId: number,
        searchParams?: URLSearchParams
    ): Promise<ApiResult<CustomerBonusSettlementDetails>> {
        return safeRequest(
            () =>
                request.get(`${this.baseUrl}/bonus-settlements/${id}/pool-customers/${customerId}/details`, {
                    params: searchParams,
                }),
            response => response.data
        );
    }
}
